// extracted by mini-css-extract-plugin
export default {"message":"invoice-modal-message_message__Hjfv4","image":"invoice-modal-message_image__2IhtL","emodji":"invoice-modal-message_emodji__hBg0o"};